import {Page, Pagination} from "../models/common";
import {MaybeComputedRef, resolveUnref, UseFetchReturn} from "@vueuse/core";
import {useFetch} from "./fetch";
import {NewOrganization, Organization, OrganizationInfo, UpdateOrganization} from "../models/organization";
import {ProjectPermission, UpdateProjectPermission} from "../models/project";
import {computed} from "vue";


export function useOrganizations(pagination: Pagination): UseFetchReturn<Page<Organization>> {
    const params = new URLSearchParams({
        sort: pagination.pagination.sortBy,
        page: (pagination.pagination.page - 1).toString(),
        size: pagination.pagination.rowsPerPage.toString(),
        direction: pagination.pagination.descending ? "DESC" : "ASC"
    })
    if (pagination.filter) {
        params.set("search", String(pagination.filter))
    }
    return useFetch<Page<Organization>>(`/organizations?${params.toString()}`, {initialData: []})
        .get()
        .json()
}

export function useOrganization(id: MaybeComputedRef<number>): UseFetchReturn<OrganizationInfo> {
    return useFetch<Organization>(`/organizations/${resolveUnref(id)}`, {initialData: []})
        .get()
        .json()
}

export function useOrganizationUsers(id: MaybeComputedRef<number>): UseFetchReturn<ProjectPermission[]> {
    const url = computed(() => !!resolveUnref(id) ? `/organizations/${resolveUnref(id)}/permissions`: '')
    return useFetch<ProjectPermission[]>(url, {refetch: true})
        .get()
        .json()
}

export function useUpdateOrganizationUsers(id: MaybeComputedRef<number>, request: UpdateProjectPermission): UseFetchReturn<null> {
    const url = computed(() => `/organizations/${resolveUnref(id)}/permissions`)
    return useFetch<null>(url)
        .post(request)
}

export function useDeleteOrganization(id: MaybeComputedRef<number>): UseFetchReturn<null> {
    const url = computed(() => `/organizations/${resolveUnref(id)}`)
    return useFetch<null>(url, {immediate: false})
        .delete()
}


export function useUpdateOrganization(id: MaybeComputedRef<number>, request: UpdateOrganization): UseFetchReturn<null> {
    const url = computed(() => `/organizations/${resolveUnref(id)}`)
    return useFetch<null>(url, {immediate: false})
        .put(request)
}

export function useAddOrganization(request: MaybeComputedRef<NewOrganization>): UseFetchReturn<null> {
    return useFetch<null>(`/organizations`, {immediate: false})
        .post(request, 'json')
}

export function useOwnedOrganization(): UseFetchReturn<Organization[]> {
    return useFetch<Organization[]>('/organizations/admin', {initialData: []})
        .get()
        .json()
}

export function useUserOrganizations(): UseFetchReturn<Organization[]> {
    return useFetch<Organization[]>('/organizations/select', {initialData: []})
        .get()
        .json()
}

export function useProjectUserOrganizations(project: MaybeComputedRef<number>): UseFetchReturn<Organization[]> {
    return useFetch<Organization[]>(`/organizations/select/project/${resolveUnref(project)}`, {initialData: []})
        .get()
        .json()
}